<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <sidenav-router-link icon="fas fa-home" to="/anasayfa" :exact="true">Ana Sayfa</sidenav-router-link>
      <sidenav-router-link icon="ion ion-ios-contacts" :to="{name:'KullaniciListesi'}"
                           v-if="yetki==='Admin' || yetki=== 'BolgeSorumlusu'" :exact="true">Kullanıcılar
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-address-book" :to="{name:'OgrenciListesi'}"
                           v-if="yetki!=='Ogrenci' && yetki!=='Hoca'" :exact="true">Öğrenciler
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-book" :to="{name:'SinifListesi'}"
                           v-if="yetki!=='Ogrenci'" :exact="true">Sınıflar
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-calendar" :to="{name:'DevamEdenler'}"
                           v-if="yetki!=='Ogrenci' && yetki!=='Hoca'" :exact="true">Devam Eden - Başlayacaklar
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file" :to="{name:'Rapor'}"
                           v-if="kullaniciId === 1 || kullaniciId===1168 || kullaniciId === 1169 || kullaniciId===1170" :exact="true">Rapor
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file" :to="{name:'TumDosyalar'}"
                           v-if="yetki!=='Ogrenci'" :exact="true">Dosyalar
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file" :to="{name:'Sinav'}"
                           v-if="yetki==='Ogrenci'" :exact="true">Sınav
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-list-ol" class="" :to="{name:'Sonuclarim'}"
                           v-if="yetki==='Ogrenci'" :exact="true">Sınav Sonuçlarım
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file" :to="{name:'Sinavlar'}"
                           v-if="yetki==='Admin'" :exact="true">Sınav Sonuç
      </sidenav-router-link>
<!--      <sidenav-router-link icon="fas fa-file" :to="{name:'Sertifika'}"
                           v-if="yetki==='Ogrenci'" :exact="true">Sertifikam
      </sidenav-router-link>-->
      <sidenav-router-link icon="ion ion-ios-person" :to="{name:'Profilim'}"
                           v-if="yetki==='Ogrenci'" :exact="true">Profilim
      </sidenav-router-link>
<!--      <sidenav-router-link icon="fas fa-file" :to="{name:'SertifikaOlusturucu'}"
                           v-if="yetki==='Admin'" :exact="true">Sertifika Oluşturucu
      </sidenav-router-link>-->
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav'
import { getId, getRole } from '../authentication/jwtParser'

export default {
  name: 'app-layout-sidenav',
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },
  data () {
    return {
      yetki: 'Ogrenci',
      kullaniciId: 0
    }
  },
  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },
  mounted () {
    let kulYetki = getRole(this.$store.getters.getToken)
    this.yetki = kulYetki

    let id = getId(this.$store.getters.getToken)
    this.kullaniciId = id
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
